import { useEffect, useState } from "react";
import { Steps } from 'antd';
import { AppDrawer } from '@/components/YhDrawer'
import { formatLocalDateTime } from "@/utils/utils";
import { IAccountAdjustDetail } from "@/views/account/AccountTypes";

interface PropsType {
    data: IAccountAdjustDetail | undefined;
    setData: (data: any) => void;
    visible: boolean;
    setVisible: (visible: boolean) => void;
}
export const ApprovalDetailDrawer = (props: PropsType) => {

    const { data, setData, visible, setVisible } = props;
    const [currentNode, setCurrentNode] = useState<number>(0);

    useEffect(() => {
        setCurrentNode(0);
        if (data?.availNodes?.length != undefined && data?.availNodes?.length > 0) {
            data?.availNodes?.map((item, index) => {
                if (item.adjustStatus == 2 || item.adjustStatus == 8) {
                    setCurrentNode(index + 1);
                }
            })
        }
    }, [data])

    return <AppDrawer
        {...{
            title: '审核详情',
            width: 450,
            visible: visible,
            closable: true,
            onOk: () => { setVisible(false); setData(null); },
            onCancel: () => { setVisible(false); setData(null); },
            showFooter: false,
        }}
    >
        <Steps style={{ margin: 30, width: 350 }} current={currentNode} progressDot={true} direction="vertical">
            <Steps.Step title={<span style={{ color: "black", fontWeight: 'bold' }}>开始</span>} />
            {data?.availNodes?.map((item) =>
                <Steps.Step
                    title={<span style={{ color: "black", fontWeight: 'bold' }}>{item.nodeTitle}</span>}
                    subTitle={<span style={{ color: "red", fontWeight: 'bold' }}>{item.adjustStatus == 0 ? "待审" : item.adjustStatus == 2 ? "审核通过" : item.adjustStatus == 8 ? "驳回" : ""}</span>}
                    description={
                        <>
                            <div style={{ color: "black" }}>审核人:<span style={{ marginLeft: 10 }}>{item.approvalUserName}</span></div>
                            <div style={{ color: "black" }}>职务:<span style={{ marginLeft: 10 }}>{item.approvalUserDuty}</span></div>
                            <div style={{ color: "black" }}>审核时间:<span style={{ marginLeft: 10 }}>{item?.adjustTime && item?.adjustTime?.length > 0 ? formatLocalDateTime(item.adjustTime) : ""}</span></div>
                        </>
                    }
                />
            )}
            <Steps.Step title={<span style={{ color: "black", fontWeight: 'bold' }}>结束</span>} />
        </Steps>

    </AppDrawer >
}